// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root{
    margin-top: 130px;
  }
  .container {
      margin: 20px auto;
      font-family: Arial, sans-serif;
      max-width: 1200px;
    }
    
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }

.assessment-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.title {
    text-align: center;
    color: #333;
    margin-bottom: 20px;
}

.risk-level, .affected-areas {
    margin-bottom: 20px;
}

.options {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

label {
    font-size: 16px;
    color: #555;
}

.submit-button_full {
    width: 100%;
    border: none;
    background-color: #fff;
    color: #ff6f61;
    border-radius: 5px;
    border: 1px solid #ff6f61;
    cursor: pointer;
    transition: background-color 0.3s ease;
    outline: none;
    height: 30px !important;
  }

  .submit-button_full:hover {
    background-color: #ff6f61;
    color: white;
  }

.risk_level{
    background: #ccc;
    width: 45px;
    height: 45px;
    border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Risk/assessment/Assessment.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;EACnB;EACA;MACI,iBAAiB;MACjB,8BAA8B;MAC9B,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,mBAAmB;IACrB;;AAEJ;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;AAEF;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".root{\r\n    margin-top: 130px;\r\n  }\r\n  .container {\r\n      margin: 20px auto;\r\n      font-family: Arial, sans-serif;\r\n      max-width: 1200px;\r\n    }\r\n    \r\n    .header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      margin-bottom: 20px;\r\n    }\r\n\r\n.assessment-container {\r\n    max-width: 600px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    background-color: #f9f9f9;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.title {\r\n    text-align: center;\r\n    color: #333;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.risk-level, .affected-areas {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.options {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\nlabel {\r\n    font-size: 16px;\r\n    color: #555;\r\n}\r\n\r\n.submit-button_full {\r\n    width: 100%;\r\n    border: none;\r\n    background-color: #fff;\r\n    color: #ff6f61;\r\n    border-radius: 5px;\r\n    border: 1px solid #ff6f61;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    outline: none;\r\n    height: 30px !important;\r\n  }\r\n\r\n  .submit-button_full:hover {\r\n    background-color: #ff6f61;\r\n    color: white;\r\n  }\r\n\r\n.risk_level{\r\n    background: #ccc;\r\n    width: 45px;\r\n    height: 45px;\r\n    border-radius: 50%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
